import illu from "../../../assets/img/illu/illu1.webp";
import "./activity.css";

export default function Activity() {
  return (
    <section className="Activity" id="about">
      <section className="ActivityHeader">
        <h2>Nos activités</h2>
        <ul>
          <li>
            <div className="line blue"></div>
            <h3>Plomberie</h3>
            <p>
              NICE PLOMBERIE se distingue dans les installations, le dépannage
              et l’entretien de tous vos réseaux d’eau : fuites, robinetterie,
              chauffe-eau, canalisation bouchée… Nos techniciens assurent
              également l’entretien préventif pour prolonger la durée de vie de
              vos installations.
            </p>
          </li>
          <li className="second">
            <div className="line pink"></div>
            <h3>Chemisage</h3>
            <p>
              Le chemisage de colonnes est une technique de rénovation sans
              démolition : projection de résine époxy ou pose de gaines
              imprégnées pour restaurer l’intérieur de vos canalisations, sans
              travaux lourds ni nuisances.
            </p>
          </li>
          <li>
            <div className="line red"></div>
            <h3>Travaux acrobatiques</h3>
            <p>
              Nos cordistes interviennent en hauteur ou en accès difficile, sans
              échafaudage ni nacelle. Réparation de descentes, recherche de
              fuites sur façades, nettoyage de verrières… un savoir-faire unique
              pour tous vos chantiers hors d’atteinte.
            </p>
          </li>
        </ul>
        <a href="#realisation" className="button">
          Notre galerie
        </a>
        {/* <img src={circle} alt="" /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 200"
          preserveAspectRatio="none"
        >
          <path d="M0,200 C360,0 1080,0 1440,200 Z" />
        </svg>
      </section>

      <ActivityInfo />
    </section>
  );
}

function ActivityInfo() {
  return (
    <section className="ActivityInfo">
      <article className="place">
        <h2>Installé au cœur de Nice</h2>
        <p>
          <strong>Notre siège : </strong>
          <a
            href="https://maps.app.goo.gl/yaS8o5yEqV3qQrgJ7"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            7 Impasse des Noisetiers, 06100 Nice
          </a>
        </p>
      </article>

      <img src={illu} alt="" />
      <article className="history">
        <h3>Tradition & Maîtrise</h3>
        <p>
          Fondée en 1949 et forte de son expérience,{" "}
          <span className="underline">NICE PLOMBERIE</span> met à votre
          disposition ses plombiers qualifiés qui vous assureront savoir-faire,
          professionnalisme et rapidité. En 75 ans, nous avons construit notre
          notoriété grâce à de solides références et vous offrons chaque jour
          notre esprit d'équipe et notre dynamisme.
        </p>
        <p>
          De <strong>Menton</strong> à <strong>Cannes</strong>, en passant par{" "}
          <strong>Monaco</strong>, <strong>Eze</strong>, <strong>Carros</strong>
          , <strong>La Gaude</strong> ou encore{" "}
          <strong>dans l’arrière pays niçois</strong>, notre équipe de plombiers
          s'appuient sur ses compétences pour un conseil, une information ou
          trouver une solution à vos problèmes.
        </p>
      </article>
    </section>
  );
}
